import { useEffect, useRef } from 'react';

const GA_ID = 'G-1QLR5FV1HM';

function loadGA() {
  if (document.getElementById('ga4-script')) return;

  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
}

function GoogleAnalytics() {
  const loaded = useRef(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookiesAccepted');
    if (consent === 'all' && !loaded.current) {
      loadGA();
      loaded.current = true;
    }

    const handleStorage = (e) => {
      if (e.key === 'cookiesAccepted' && e.newValue === 'all' && !loaded.current) {
        loadGA();
        loaded.current = true;
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return null;
}

export default GoogleAnalytics;
